import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    DeleteButton,
    TopToolbar,
    CreateButton,
    FilterButton,
    TextInput,
    BooleanInput,
} from 'react-admin';
import { Chip } from '@mui/material';

const tokenFilters = [
    <TextInput key="q" label="Search" source="q" alwaysOn />,
    <BooleanInput key="activeOnly" label="Active Only" source="activeOnly" defaultValue={true} />,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <CreateButton />
    </TopToolbar>
);

interface TokenRecord {
    isRevoked: boolean;
    isExpired: boolean;
    isRateLimited: boolean;
    isValid: boolean;
    usageCount: number;
    maxUsage: number | null;
}

const StatusField = ({ record }: { record?: TokenRecord }) => {
    if (!record) return null;

    if (record.isRevoked) {
        return <Chip label="Revoked" color="error" size="small" />;
    }
    if (record.isExpired) {
        return <Chip label="Expired" color="default" size="small" />;
    }
    if (record.isRateLimited) {
        return <Chip label="Rate Limited" color="warning" size="small" />;
    }
    if (record.isValid) {
        return <Chip label="Active" color="success" size="small" />;
    }
    return <Chip label="Inactive" color="default" size="small" />;
};

export const BootstrapTokenList = () => (
    <List filters={tokenFilters} actions={<ListActions />}>
        <Datagrid rowClick="show">
            <TextField source="name" />
            <FunctionField label="Status" render={(record: TokenRecord) => <StatusField record={record} />} />
            <FunctionField
                label="Usage"
                render={(record: TokenRecord) => `${record.usageCount} / ${record.maxUsage || '∞'}`}
            />
            <DateField source="createdAt" showTime />
            <DateField source="expiresAt" showTime />
            <DeleteButton mutationMode="pessimistic" />
        </Datagrid>
    </List>
);
